import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonAlert, IonIcon, IonItem, IonLabel, IonInput, IonButton } from "@ionic/react";
import { personCircle } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { ApiChangePassword } from "../apiproviders/dataprovider";
import { app } from "../configs/appcfg";
import { createStore } from "../data/persistent/IonicStore";



const PasswordChange: React.FC = () => {
    const history = useHistory();
    const [userInfo,setUserInfo] = useState<any|null>(null);
    const [oldPass,setOldPass] = useState<string|null>(null);
    const [username, setUsername] = useState<string|null>(null);
    const [newpassword, setNewPassword] = useState<string>("");
    const [re_newpassword, setReNewPassword] = useState<string>("");
    const [iserror, setIserror] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [messageTitle, setMessageTitle] = useState<string>('Thông báo!');
    useEffect(()=>{
      const loadStoreData = async(key:string)=>{
          //console.log('load local data');
          let lcStorage = await createStore();
          let info = await lcStorage.get(key);
          if(info !== null){
            let infoObj = JSON.parse(info);
            setUserInfo(infoObj);
            setOldPass(infoObj.passcode);
            setUsername(infoObj.mathisinh);
          }
      };
      loadStoreData("login_info");
    },[])
    const handleChangePassword = async() => {
        if (!username || username.length === 0 || username ==="") {
          setMessageTitle('Thông báo');
            setMessage("Tên đăng nhập không hợp lệ");
            setIserror(true);
            return;
        }
        if (!newpassword || newpassword.length < app.rules.minPasswordLength || newpassword.length > app.rules.maxPasswordLength) {
          setMessageTitle('Thông báo');  
          setMessage(`Độ dài mật khẩu [tối thiểu: ${app.rules.minPasswordLength}, tối đa: ${app.rules.maxPasswordLength}] ký tự`);
            setIserror(true);
            return;
        }
        if(newpassword !== re_newpassword){
          setMessageTitle('Thông báo');
          setMessage("Mật khẩu mới không khớp");
            setIserror(true);
            return;
        }
        try {
          const paswordChangeData = {
            "mathisinh": username,
            "passcode": newpassword,
            "token": userInfo.token
          }
          let res = await ApiChangePassword(paswordChangeData);
          if([204,200].indexOf(res.status) !== -1)
          {  
            let new_item = {...userInfo, passcode: newpassword,changePasswordRequired: false}; 
            //lưu dữ liệu xuống local store
            try {
                let localStore = await createStore();
                await localStore.set("login_info", JSON.stringify(new_item));
                history.push("/profile");
            } catch (error) {
              //console.log(error);
              setMessageTitle('Lỗi lưu dữ liệu');
              setMessage("Không lưu được dữ liệu cục bộ, kiểm tra trình duyệt hoặc ứng dụng");
              setIserror(true);
            }
          }else{
            setMessageTitle('Lỗi kết nối');
            setMessage("Lỗi đường truyền! Kiểm tra kết nối internet");
            setIserror(true);
          }           
      } catch (error) {
        setMessageTitle('Lỗi xác thực');
        setMessage("Không xác thực được tài khoản.Nhắn tin zalo 0978555950 để được hỗ trợ");
        setIserror(true);
      }
    };
    
    return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{username} - Yêu cầu đổi mật khẩu</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding ion-text-center">
        <IonGrid>
        <IonRow>
          <IonCol>
            <IonAlert
                isOpen={iserror}
                onDidDismiss={() => setIserror(false)}
                cssClass="my-custom-class"
                header={messageTitle}
                message={message}
                buttons={["OK"]}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonIcon
                style={{ fontSize: "70px", color: "#0040ff" }}
                icon={personCircle}
            />
          </IonCol>
        </IonRow>
          <IonRow>
            <IonCol>
            <IonItem>
            <IonLabel position="floating">Tên đăng nhập</IonLabel>
            <IonInput
                type="text"
                value={username}
                disabled
                //onIonChange={(e) => setUsername(e.detail.value!)}
                >
            </IonInput>
            </IonItem>
            </IonCol>
          </IonRow>
    
          <IonRow>
            <IonCol>
            <IonItem>
              <IonLabel position="floating">Mật khẩu mới</IonLabel>
              <IonInput
                type="password"
                value={newpassword}
                onIonChange={(e) => setNewPassword(e.detail.value!)}
                placeholder={`Độ dài MK[min: ${app.rules.minPasswordLength}, max: ${app.rules.maxPasswordLength}] ký tự`}
                >
              </IonInput>
            </IonItem>
            <IonItem>
              <IonLabel position="floating">Nhập lại khẩu mới</IonLabel>
              <IonInput
                type="password"
                value={re_newpassword}
                onIonChange={(e) => setReNewPassword(e.detail.value!)}
                placeholder={`Độ dài MK[min: ${app.rules.minPasswordLength}, max: ${app.rules.maxPasswordLength}] ký tự`}
                >
              </IonInput>
            </IonItem>
            <IonItem>
              <IonLabel color={"danger"}>{`* Lưu ý: Độ dài MK[min: ${app.rules.minPasswordLength}, max: ${app.rules.maxPasswordLength}] ký tự`}</IonLabel>
            </IonItem>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonButton expand="block" onClick={handleChangePassword}>Đổi mật khẩu</IonButton>
              
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
    );
    };
    
    export default PasswordChange;